<template>
  <el-container class="index-box">
    <el-header class="flex-between center">
      <div class="national_emblem_box">
        <img
          src="../../assets/images/backstageManagement/national_emblem.png"
          class="national_emblem"
          alt
          srcset
        />
        <span>杭州卓智力创信息技术有限公司</span>
      </div>
      <div class="func flex-end items">
        <div @click="routerFun('/news','news')" :class="[itemact == 'news' ? 'active' : '']" class="nav flex-center items">信息发布</div>
        <div @click="routerFun('/system','system')" :class="[itemact == 'system' ? 'active' : '']" class="nav flex-center items">系统维护</div>
        <!-- <div class="user flex-center items">
          <img
            class="img"
            src="../../assets/images/backstageManagement/timg.jpg"
            alt=""
            srcset=""
          />
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{user.userName}}<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-plus">
                <span  @click="checkoutFun">退出</span>
                </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
         <div class="checkout flex-center items" @click="routerFun1('/index','')">
          <img
            src="../../assets/images/backstageManagement/icon_home.png"
            alt=""
            srcset=""
          />
          <span>返回主页</span>
        </div>
        <!-- <div class="checkout flex-center items" @click="checkoutFun">
          <img
            src="../../assets/images/backstageManagement/icon_checkout.png"
            alt=""
            srcset=""
            class="img"
          />
          <span>注销</span>
        </div> -->
      </div>
    </el-header>
    <router-view></router-view>

  </el-container>
</template>

<script>
export default {
  data() {
    return {
      itemact:'',
      user:{}
    };
  },
  // beforeRouteEnter:(to,from,next)=>{
  //       next(vm=>{
  //           alert("hello" + vm.name);
  //       })
  //   },
  created() {
    // ,JSON.stringify(res.data)
    this.user = JSON.parse(window.sessionStorage.getItem('user')) || {};
    let href = window.location.href.split('/');
    this.itemact = href[href.length - 1]

  },
  methods: {
    routerFun(str,str1){
      if(str1){
         this.itemact = str1;
      }
     
      this.$router.push({ path: str })
    },
    checkoutFun(){
      window.sessionStorage.clear(); 
      this.$router.push({ path: '/login' })
    },
    routerFun1(){
      let routeUrl = this.$router.resolve({
        path: "/index"
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style scoped lang="less">
.el-container {
  height: 100vh;
  font-size: 15px;
}
.index-box {
  .national_emblem_box {
    height: 90px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 300px;
    img {
      margin-right: 10px;
      width: 30px;
      height: auto;
    }
  }
  .func {
    .nav {
      width: 120px;
      height: 36px;
      cursor:pointer;
      border-radius: 18px;
      &.active {
        background: rgba(0, 126, 255, 1);
      }
    }

    .user {
      padding: 0 60px;
      
      .el-dropdown{
        cursor:pointer;
      }
      .img {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        object-fit: cover;
        margin-right: 10px;
      }

      .el-dropdown-link {
        color: #fff;
      }
      .el-icon-caret-bottom {
        margin-left: 10px;
      }
    }
    .checkout {
      padding-right: 50px;
      cursor: pointer;
      padding-left: 10px;
      // width: 200px;
      img {
        margin-right: 10px;
        width: 40px;
        height: auto;
      }
      .img {
        margin-right: 10px;
        width: 27px;
        height: auto;
      }
    }
  }

  /deep/ .el-aside {
    width: 220px !important;
    background: rgba(0, 23, 92, 1);
    color: #ffffff;
  }
  .el-header {
    box-shadow: 0px 1px 3px 0px rgba(0, 43, 77, 0.3);
    background: #01134a;
    height: 90px !important;
    color: #ffffff;
    padding-left: 17px;
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .flex-start {
    display: flex;
    justify-content: flex-start;
  }
  .items {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
}

@media only screen and (max-width: 1700px) {
    .index-box{
      .func {
        .checkout{
          padding-right: 40px;
        }
        .user{
          padding: 0 50px;
        }
        .nav{
          width: 110px;
        }
      }
    } 
}
</style>
